import React from 'react';

export const DrawerField = ({ label, value }: { label: string; value: React.ReactNode }) => (
    <div className="space-y-1">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">{label}</p>
        <div className="text-sm text-gray-700">{value}</div>
    </div>
);

export const DrawerBadge = ({ children, className }: { children: React.ReactNode; className: string }) => (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${className}`}>
        {children}
    </span>
);
